import { ErrorPlatformEvent, assign } from '@monofront/xstate-v4';
import {
  CheckoutCartMachineContext,
  GetCheckoutCartSuccessEvent,
  StartCheckoutEvent,
} from './types';
import { isCheckoutCartStale } from './guards';

export const assignUserReady = assign<CheckoutCartMachineContext>({
  isUserReady: true,
});

export const assignCart = assign<
  CheckoutCartMachineContext,
  GetCheckoutCartSuccessEvent
>({
  checkoutCartId: (_, event) => event.data.cart.id,
  checkoutCart: (_, event) => event.data.cart,
});

export const assignProducts = assign<
  CheckoutCartMachineContext,
  StartCheckoutEvent
>({
  products: (_, event) => event.products,
});

export const dropStaleCart = assign<
  CheckoutCartMachineContext,
  StartCheckoutEvent
>((context, event) =>
  isCheckoutCartStale(context, event)
    ? { checkoutCartId: null, checkoutCart: null }
    : {},
);

export const assignError = assign<
  CheckoutCartMachineContext,
  ErrorPlatformEvent
>({
  errors: (_, event) => (Array.isArray(event.data) ? event.data : [event.data]),
});
